export class PayPalCheckoutInstanceMissingError extends Error {
  constructor() {
    super('PayPal checkout instance is missing.');
    this.name = 'PayPalCheckoutInstanceMissingError';
  }
}
